export default "__VITE_ASSET__bc7e8d6a__"